import {
  setClientListingEditPrefill,
  setClientListingPrefill,
  setClientReviewDraft,
  setMessageDraft,
  setPartnerMarketplaceFilters,
} from './storage';

export function applyAiHandoffRoute({ handoffRoute, navigate }) {
  if (!handoffRoute?.routeKey) {
    return false;
  }

  const params = handoffRoute.params || {};

  switch (handoffRoute.routeKey) {
    case 'client.listings.create':
      setClientListingPrefill(params.prefill || {});
      navigate('/create-listing');
      return true;
    case 'client.listings':
      navigate('/my-listings');
      return true;
    case 'client.listings.edit':
      if (params.listingId) {
        setClientListingEditPrefill(params.listingId, params.prefill || {});
        navigate(`/my-listings/${params.listingId}`);
      } else {
        navigate('/my-listings');
      }
      return true;
    case 'client.listings.detail':
      if (params.listingId) {
        navigate(`/my-listings/${params.listingId}`);
      } else {
        navigate('/my-listings');
      }
      return true;
    case 'client.messages':
      navigate('/my-listings');
      return true;
    case 'client.messages.thread':
      if (params.listingId) {
        setMessageDraft({
          role: 'client',
          listingId: params.listingId,
          draft: typeof params.draft === 'string' ? params.draft : '',
        });
        navigate(`/my-listings/${params.listingId}?tab=messages`);
      } else {
        navigate('/my-listings');
      }
      return true;
    case 'client.reviews.create':
      if (params.listingId) {
        setClientReviewDraft({
          listingId: params.listingId,
          quoteId: params.quoteId || null,
          partnerId: params.partnerId || null,
          stars: params.stars || null,
          sentiment: params.sentiment || null,
          comment: typeof params.comment === 'string' ? params.comment : '',
        });
        navigate(`/reviews/create/${params.listingId}`);
      } else {
        navigate('/my-listings');
      }
      return true;
    case 'partner.marketplace':
      setPartnerMarketplaceFilters({
        ...(params.filters || {}),
        categories: Array.isArray(params.filters?.categories)
          ? params.filters.categories
          : params.filters?.category
            ? [params.filters.category]
            : [],
      });
      navigate('/search');
      return true;
    case 'partner.marketplace.detail':
    case 'partner.jobs.detail':
      if (params.listingId) {
        navigate(`/listings/${params.listingId}`);
      } else {
        navigate('/search');
      }
      return true;
    case 'partner.messages':
      navigate('/search');
      return true;
    case 'partner.messages.thread':
      if (params.listingId) {
        setMessageDraft({
          role: 'partner',
          listingId: params.listingId,
          draft: typeof params.draft === 'string' ? params.draft : '',
        });
        navigate(`/listings/${params.listingId}?tab=messages`);
      } else {
        navigate('/search');
      }
      return true;
    case 'partner.fleet':
      navigate('/fleet');
      return true;
    case 'partner.invoices':
      navigate('/my-invoices');
      return true;
    default:
      return false;
  }
}
